import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=3ae2cee4&scoped=true&"
import script from "./Movements.vue?vue&type=script&lang=js&"
export * from "./Movements.vue?vue&type=script&lang=js&"
import style0 from "./Movements.vue?vue&type=style&index=0&id=3ae2cee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2cee4",
  null
  
)

component.options.__file = "Movements.vue"
export default component.exports